var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RequestError, request } from "../request";
import { API_V1_PATH } from "../config";
export const logout = ({}) => __awaiter(void 0, void 0, void 0, function* () {
    yield request(`${API_V1_PATH}/auth/logout`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        }
    }).catch((error) => {
        if (error instanceof RequestError &&
            (error.status === 401 || error.status === 403)) {
            return true;
        }
    });
    return true;
});
